import PropTypes from 'prop-types';
import { ShieldCheck, History } from 'lucide-react';

const safeRelative = (iso) => {
  if (!iso) return '';
  const ms = Date.now() - new Date(iso).getTime();
  if (Number.isNaN(ms)) return iso;
  const sec = Math.round(ms / 1000);
  if (sec < 60) return `${sec}s ago`;
  const min = Math.round(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.round(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.round(hr / 24);
  return `${day}d ago`;
};

const AgentSidebar = ({ auditLog, sessionId }) => (
  <aside className='hidden w-[260px] shrink-0 flex-col border-l border-gray-100 dark:border-gray-700 bg-gray-50/60 dark:bg-[#0F1A2A] sm:flex'>
    <div className='border-b border-gray-100 dark:border-gray-700 px-4 py-3'>
      <p className='inline-flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400'>
        <ShieldCheck className='h-3 w-3' />
        Session
      </p>
      <p className='mt-1 font-mono text-[11px] text-gray-700 dark:text-gray-300 truncate'>
        {sessionId || 'not started'}
      </p>
    </div>
    <div className='flex flex-col gap-3 overflow-y-auto px-4 py-3'>
      <p className='inline-flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400'>
        <History className='h-3 w-3' />
        Recent actions
      </p>
      {auditLog.length === 0 ? (
        <p className='text-xs text-gray-500 dark:text-gray-400'>
          No mutations yet. Read-only queries don&apos;t appear here.
        </p>
      ) : (
        <ul className='flex flex-col gap-2'>
          {auditLog.map((row) => (
            <li
              key={row.id}
              className='rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-[#1D2838] px-3 py-2'
            >
              <p className='text-xs font-semibold text-gray-900 dark:text-white'>{row.action}</p>
              <p className='mt-0.5 text-[11px] text-gray-500 dark:text-gray-400 truncate'>
                {row.actor_name || row.actor_email || 'unknown'} · {safeRelative(row.created_at)}
              </p>
              {row.status && row.status !== 'success' ? (
                <p className='mt-1 text-[10px] font-semibold uppercase tracking-wider text-amber-600 dark:text-amber-400'>
                  {row.status}
                </p>
              ) : null}
            </li>
          ))}
        </ul>
      )}
    </div>
  </aside>
);

AgentSidebar.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  auditLog: PropTypes.array,
  sessionId: PropTypes.string
};

AgentSidebar.defaultProps = {
  auditLog: [],
  sessionId: undefined
};

export default AgentSidebar;
